import { noddiAsync, URLKeys } from 'noddi-async';

export const useMemberDrivenCars = (userGroupId: number, userGroupMemberId: number) =>
  noddiAsync.useGet({
    type: URLKeys.getPaginatedNotificationOverviewCars,
    input: {
      userGroupId,
      managerUserGroupMemberIds: [userGroupMemberId],
      pageIndex: 0,
      pageSize: 5
    }
  });
